import {
  FormControl,
  FormLabel,
  Textarea,
  Input,
  Button,
  HStack,
  Select,
  Flex,
  Text,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { createHouse } from "../pages/Manager-Portal/House/service/createHouse";
import { getAllResidents } from "../pages/Manager-Portal/Resident/service";
import { _COLORS } from "../app/constants";

const labelFonstSize = { fontSize: "13px" };

export const labelStyles = {
  // color: "#140005C2",
  color: "#000",
  fontSize: "1.2em",
};

export const textInputStyles = {
  bg: "#fff",
  color: "black",
  border: "1px solid #E6E6E6",
  fontSize: "1.2em",
  _focus: { boxShadow: "none" },
};

const CreateHouseForm = ({ streets, onClose, setRefresh }) => {
  const userId = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(false);
  const [streetId, setStreetId] = useState("");
  const [designation, setDesignation] = useState("landlord");
  const [estateValue, setEstateValue] = useState({ houseNumber: "" });

  const initialValues = {
    
    streetId,
    direction: "",
    userId,
  };
  const labelFontSize = { fontSize: "13px" };

  const [formValues, setFormValues] = useState(initialValues);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [locationLoading, setLocationLoading] = useState(false); // New state for button loading

  const handleEstateChange = (e) => {
    setEstateValue({ ...estateValue, [e.target.name]: e.target.value });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };


  const disable = Boolean(estateValue.houseNumber) && Boolean(streetId);


  const handleCreate = () => {
    const { houseNumber } = estateValue;
    // const { phoneNumber, ...payloadWithoutPhoneNumber } = formValues;
    // const phoneNumber = formValues.phoneNumber || "08000000000";
    const payload = {
      houseNumber: houseNumber,
      userId,
      streetId,
      locationLng: location.longitude, // Send longitude directly
      locationLat: location.latitude, // Send latitude directly
    };

    createHouse(payload, setLoading, onClose, setRefresh);
  };

  useEffect(() => {
    setFormValues((initial) => ({ ...initial, estate: [estateValue] }));
  }, [estateValue]);

  const handleGetLocation = () => {
    if (navigator.geolocation) {
      setLocationLoading(true); // Show loading state
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          setLocationLoading(false); // Stop loading state
        },
        (error) => {
          console.error("Error obtaining location:", error);
          setLocationLoading(false); // Stop loading state
        },
        { enableHighAccuracy: true }
      );
    }
  };

  return (
    <FormControl
      id="createCategories"
      display="flex"
      flexDirection="column"
      fontSize="13px"
      
    >
      {/* <FormLabel {...labelFonstSize} {...labelStyles}>
        Designation
      </FormLabel>
      <Select
        mb="10px"
        onChange={(e) => setDesignation(e.target.value)}
        value={designation}
        bg="white"
        border="1px solid #E6E6E6"
        fontSize="1.2em"
        color={"#1d8c23"}
        // _focus= { boxShadow: "none" }
        // {...textInputStyles}
      >
        <option value="landlord">Landlord</option>
        <option value="tenant">Tenant</option>
        <option value="agent">Agent</option>
      </Select>
      <FormLabel {...labelFonstSize} {...labelStyles}>
        {designation?.charAt(0)?.toUpperCase() + designation.slice(1)} Name
      </FormLabel>
      <Input
        mb={4}
        value={formValues.name}
        type="text"
        name="name"
        onChange={handleChange}
        {...textInputStyles}
      />

      <FormLabel {...labelFonstSize} {...labelStyles}>
        Phone Number
      </FormLabel>
      <Input
        mb={4}
        value={formValues.phoneNumber}
        type="number"
        name="phoneNumber"
        onChange={handleChange}
        {...textInputStyles}
      />
      <FormLabel{...labelFonstSize} {...labelStyles}>
        Email
      </FormLabel>
      <Input
        mb={4}
        value={formValues.email}
        type="text"
        name="email"
        onChange={handleChange}
        {...textInputStyles}
      /> */}
      <FormLabel  {...labelFonstSize} {...labelStyles}>
        Street
      </FormLabel>
      <Select
        placeholder="Select Street"
        name="streetId"
        onChange={(e) => setStreetId(e.target.value)}
        mb="20px"
        bg="white"
        border="1px solid #E6E6E6"
        fontSize="1.2em"
        color={"#000"}
        // {...textInputStyles}
      >
        {streets?.map((street) => (
          <option value={street?._id}>
            {street?.streetName || "No street available yet"}
          </option>
        ))}
      </Select>

      <HStack spacing={8}>
        <Flex direction="column" width={"100%"}>
          <FormLabel {...labelFonstSize} {...labelStyles}>
            House number
          </FormLabel>
          <Input
            width={"100%"}
            mb={4}
            value={estateValue?.houseNumber}
            type="text"
            name="houseNumber"
            onChange={handleEstateChange}
            {...textInputStyles}
          />
        </Flex>
      </HStack>
      <FormLabel {...labelFonstSize} {...labelStyles}>
        Direction to the house
      </FormLabel>
      <Textarea
        mb={4}
        resize="none"
        value={formValues.direction}
        type="text"
        name="direction"
        onChange={handleChange}
        {...textInputStyles}
      />
      {/* Get Location Button */}
      <Button
        mb={4}
        onClick={handleGetLocation}
        isLoading={locationLoading}
        bg="#001001"
        color="white"
        _hover={{ bg: "#002002" }} // Optional: Slightly lighter color for hover effect
        _focus={{ boxShadow: "none" }}
      >
        Get Current Location
      </Button>

      {/* Display Latitude and Longitude */}
      {location.latitude && location.longitude && (
        <Text mb={4}>
          <strong>Latitude:</strong> {location.latitude},{" "}
          <strong>Longitude:</strong> {location.longitude}
        </Text>
      )}

      <Button
        bg={_COLORS.brand}
        color="#fff"
        _hover={{ bg: _COLORS.brand }}
        _focus={{ boxShadow: "none" }}
        h={50}
        fontWeight="medium"
        onClick={handleCreate}
        isLoading={loading}
        disabled={!disable}
      >
        Create New House
      </Button>
    </FormControl>
  );
};

export default CreateHouseForm;
